import {
    CompositeChart as MantineCompositeChart,
    CompositeChartProps as MantineCompositeChartProps,
} from '@mantine/charts';

import { FC } from 'react';

import compositeChartStyles from './CompositeChart.module.css';
import { joinClassNames } from '../../../utils/joinClassNames';

export type CompositeChartProps = MantineCompositeChartProps;

export const CompositeChart: FC<CompositeChartProps> = ({
    data,
    series,
    curveType = 'linear',
    withDots = false,
    className,
    ...props
}) => {
    return (
        <MantineCompositeChart
            className={joinClassNames(compositeChartStyles.root, className)}
            data={data}
            series={series}
            curveType={curveType}
            withDots={withDots}
            strokeWidth={1}
            strokeDasharray="0"
            xAxisProps={{
                axisLine: true,
            }}
            yAxisProps={{
                axisLine: true,
                stroke: 'var(--graphic-status-disabled)',
            }}
            {...props}
        />
    );
};
